export function dotVisible(
  unseen: boolean | undefined,
  current: number | null,
): boolean {
  if (current === 0) {
    return false;
  }
  return unseen === true;
}
